<rask-action-button
    class="mx-0"
    icon="far fa-plus"
    aid="buttonCreateTradslag"
    [options]="tradslagOptions"
    (optionSelected)="tradslagSelected($event)"
    [showChevron]="false"
    [disabled]="readonly">
    Lägg till trädslag
</rask-action-button>